<script setup lang="ts">
const {data, refresh} = await useApiFetchCaseList({
  page: 1,
  size: 6
})

onMounted(() => {
  refresh()
})

</script>

<template>
  <section class="block3">
    <div class="blockCenter">
      <div class="titleFloor">
        <div class="title">
          相关扶持<span>案例</span>
        </div>
      </div>
      <div class="caseListBlock">
        <!--        <Block3CaseList/>-->
        <div class="caseList" v-if="data">
          <div v-for="(item,index) in data.list" class="caseWrapper">
            <div class="imgWrapper">
              <img :src='item.img' alt='图片' class="img"/>
            </div>
            <div class="panel">
              <div class="titleFloor">
                <div class="title">
                  {{ item.name }}
                </div>
              </div>
              <div class="line"/>
              <div class="content">
                {{ item.content }}
              </div>
              <div class="btnFloor">
                <div class="btnToInfo" @click="navigateTo(item.url,{external: true,open:{target:'_blank'}})">
                  <div class="text">点击进入</div>
                  <div class="iconArrowWrapper">
                    <img src="/img/policy/img/block3_进入.png" alt='进入' class="img">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
section.block3 {
  margin-top: 81px;

  .blockCenter {
    @include glx-center-block;

    > .titleFloor {
      text-align: center;

      > .title {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #040000;
        line-height: 33px;

        span {
          color: rgba(255, 1, 1, 1);
        }
      }

    }

    .caseListBlock {
      margin-top: 60px;

      .caseList {
        $item-width: 582px;

        width: $item-width * 2 + 36px;
        display: flex;
        //justify-content: space-between;
        flex-wrap: wrap;

        margin-left: auto;
        margin-right: auto;
        position: relative;

        > .caseWrapper {
          width: 582px;
          height: 342px;
          position: relative;

          > .imgWrapper {
            width: 100%;
            height: 100%;
            position: relative;

            > .img {
              width: 100%;
              height: 100%;
              object-fit: fill;
            }
          }

          > .panel {
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(0, 0, 0, 0.8);

            box-sizing: border-box;
            padding-top: 82px;

            flex-direction: column;

            > .titleFloor {
              box-sizing: border-box;
              padding-left: 44px;

              > .title {
                font-family: PingFang SC;
                font-weight: bold;
                font-size: 32px;
                color: #FFFFFF;
                line-height: 1;
              }
            }

            > .line {
              width: 491px;
              height: 1px;
              background: rgba(255, 255, 255, 0.6);

              margin-left: 46px;
              margin-top: 18px;
            }

            > .content {
              margin-top: 21px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 18px;
              color: #FFFFFF;
              line-height: 28px;

              width: 485px;
              height: 110px;
              margin-left: 44px;

              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box; //作为弹性伸缩盒子模型显示。
              -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
              -webkit-line-clamp: 4; //显示的行
            }

            > .btnFloor {
              margin-top: auto;
              margin-bottom: 15px;

              > .btnToInfo {
                width: 128px;
                height: 38px;
                background: rgba(255, 255, 255, 0.3);
                border-radius: 4px;
                border: 1px solid #FFFFFF;

                display: flex;
                align-items: center;
                margin-left: auto;
                margin-right: 18px;

                > .text {
                  font-family: PingFang SC;
                  font-weight: 400;
                  font-size: 16px;
                  color: #FFFFFF;
                  line-height: 1;
                  margin-left: 21px;
                }

                > .iconArrowWrapper {
                  position: relative;
                  width: 16px;
                  height: 14px;
                  margin-left: 7px;

                  .img {
                    width: 100%;
                    height: 100%;
                    object-fit: fill;
                  }
                }
              }
            }
          }

          &:hover {
            cursor: pointer;

            > .panel {
              display: flex;
            }
          }

          &:nth-child(2n) {
            margin-left: 36px;
          }

          &:nth-child(n + 3) {
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>